///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { ChangeDetectionStrategy, Component } from '@angular/core';
import { selectShowEditButtonPermission } from '../../users/store/users-list.selectors';
import { map } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { selectRouteData } from '../../router-store/router.selector';
import { DialogAction } from '../../dialog-manager/dialog-action-enum';
import { Observable } from 'rxjs';

@Component({
    selector: 'winde-users-panel',
    templateUrl: './users.component.html',
    styles: [
        `
            .users-panel {
                margin: 20px;
            }
        `
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class GtthUsersComponent {
    public baseUrl$: Observable<string> = this.store.select(selectRouteData).pipe(map((routeData) => routeData.tabName));
    public showEditBtn$: Observable<boolean> = this.store.select(selectShowEditButtonPermission);
    public action = DialogAction;

    constructor(protected readonly store: Store) {}
}
